<template>
  <b-badge :class="`font-size-12 status--${filterStatus}`">
    <span >{{ statusLabel }}</span>
  </b-badge>
</template>

<script>
const STATUS_ALIASES = {
  completed_paid: 'paid',
  expiration_paid: 'paid',
  completed_due: 'due',
  expiration_due: 'due'
}

export default {
  name: 'MainStatus',
  props: {
    status: {
      type: String
    }
  },
  computed: {
    statusKey () {
      return this.status ? this.status.toLowerCase().replace(/ /g, '_') : ''
    },
    filterStatus () {
      return STATUS_ALIASES[this.statusKey] || this.statusKey
    },
    statusLabel () {
      return STATUS_ALIASES[this.statusKey] || this.status
    }
  }
}
</script>
